import { render, staticRenderFns } from "./follow-dialog.vue?vue&type=template&id=0f03bc4f&scoped=true"
import script from "./follow-dialog.vue?vue&type=script&lang=js"
export * from "./follow-dialog.vue?vue&type=script&lang=js"
import style0 from "./follow-dialog.vue?vue&type=style&index=0&id=0f03bc4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f03bc4f",
  null
  
)

export default component.exports